const slideModule2 = {
  // other module props
  id: 2,
  component: "CRVideoSlide",
  config: {
    header: {
      isTextInCaps: false,
      text: "Aute et culpa quis nulla minim dolore cupidatat",
      textColor: {
        label: "Color 1",
        value: "#1D1D1F",
      },
    },
    text: {
      text: "Nulla incididunt elit ex qui exercitation. Laboris minim ipsum dolor voluptate mollit voluptate cupidatat aliqua sint culpa. Non elit non esse commodo fugiat qui laboris labore. Lorem aute sint mollit. Lorem aute sint mollit.",
      textColor: {
        label: "Color 2",
        value: "#566A7A",
      },
    },
    ctaButton: {
      text: "Learn more",
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link",
          value: "external",
        },
        url: "https://www.example.com",
        scrollTarget: {
          label: "FAQ",
          value: "7c205826-8720-3b35-884d-b4aa2a32b7f9",
        },
        target: {
          label: "New Tab",
          value: "_blank",
        },
      },
      backgroundColor: {
        label: "Black",
        value: "#000",
      },
      textColor: {
        label: "Green",
        value: "#2bcd41",
      },
    },
    general: {
      paddings: {
        top: true,
        bottom: true,
      },
      backgroundColor: {
        label: "Cornsilk",
        value: "#aaeeff",
      },
      playButtonColor: {
        label: "Cornsilk",
        value: "#00bb00",
      },
      thumbnail: {
        media: {
          url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
          mediaType: "image",
        },
      },
      video: {
        source: {
          label: "YouTube",
          value: "youtube",
        },
        uploadedVideo: {
          media: {
            url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
            mediaType: "video",
          },
        },
        // YouTube
        embeddedVideoUrl:
          "https://www.youtube.com/shorts/SXHMnicI6Pg?feature=share",

        // Vimeo
        //embeddedVideoUrl: "https://player.vimeo.com/video/875784142?h=3ed6db7c17&autoplay=1"

        // Watchado
        //embeddedVideoUrl: "https://www.whatchado.com/de/embeds/videos/vertriebbeiwhatchado"

        // Other source
        //embeddedVideoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      },
    },
  },
};

export default slideModule2;
